'use client';

import { useEffect } from 'react';
import { useSiteConfig } from '@commons/SiteConfig';

const WIDGET_SELECTOR = 'iframe[src*="gotobooking.io"]';
const HIDDEN_CLASS = 'gtbw-display-none-iframe-style';

/**
 * The booking widget (gotowidget.js) injects an untitled iframe and does not
 * return focus when it closes. Name the frame and send focus back to the
 * control that opened it.
 */
export default function BookingWidgetA11y() {
  const { dictionary } = useSiteConfig();
  const title = dictionary?.booking?.widgetTitle || 'Booking';

  useEffect(() => {
    let trigger = null;

    const labelFrames = () => {
      document.querySelectorAll(WIDGET_SELECTOR).forEach((frame) => {
        if (frame.title !== title) frame.title = title;
      });
    };

    const rememberTrigger = (e) => {
      const link = e.target.closest?.('a[href*="gotohubwidget"], [data-gtbw]');
      if (link) trigger = link;
    };

    const observer = new MutationObserver((mutations) => {
      labelFrames();
      mutations.forEach(({ type, target }) => {
        const isClosed = type === 'attributes' && target.matches?.(WIDGET_SELECTOR) && target.classList.contains(HIDDEN_CLASS);
        if (isClosed && trigger?.isConnected) {
          trigger.focus();
          trigger = null;
        }
      });
    });

    labelFrames();
    document.addEventListener('click', rememberTrigger, true);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    return () => {
      document.removeEventListener('click', rememberTrigger, true);
      observer.disconnect();
    };
  }, [title]);

  return null;
}
